module.exports = __webpack_public_path__ + "zarustajici-nehty_5_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/obecna-a-zilni-chirurgie/zarustajici-nehty_5_before.jpg
// module id = 1046
// module chunks = 0